import React from 'react';
import { Globe, Clock, FileX } from 'lucide-react';
import { getThemeClass } from '../../../../utils/theme';

const PostList = ({ 
  posts, 
  selectedPostId, 
  onSelect, 
  theme = 'dark' 
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Not published';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="h-full flex flex-col">
      <div className={`p-3 border-b ${getThemeClass(theme, 'border')}`}>
        <h3 className={`text-sm font-medium ${getThemeClass(theme, 'text.secondary')}`}>
          Posts ({posts.length})
        </h3>
      </div>
      
      <div className="flex-1 overflow-y-auto">
        {posts.length === 0 ? (
          <div className={`p-4 text-center ${getThemeClass(theme, 'text.secondary')}`}>
            <FileX className="w-8 h-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">No posts yet</p>
            <p className="text-xs opacity-75">Click "New Post" to create one</p>
          </div>
        ) : (
          <ul className="py-2">
            {posts.map(post => (
              <li key={post.post_id}>
                <button
                  onClick={() => onSelect(post.post_id)}
                  className={`w-full px-4 py-3 text-left flex items-start gap-3 transition-colors
                    ${selectedPostId === post.post_id 
                      ? 'bg-blue-500/20 border-l-2 border-blue-500' 
                      : `hover:bg-slate-700/50 border-l-2 border-transparent`
                    }`}
                >
                  {post.status === 'PUBLISHED' ? (
                    <Globe className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
                  ) : (
                    <Clock className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
                  )}
                  <div className="flex-1 min-w-0">
                    <div className={`text-sm font-medium truncate ${getThemeClass(theme, 'text.primary')}`}>
                      {post.title}
                    </div>
                    <div className={`text-xs ${getThemeClass(theme, 'text.secondary')}`}>
                      {post.status === 'PUBLISHED' 
                        ? formatDate(post.published_at)
                        : 'Draft'}
                    </div>
                  </div>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default PostList;









